import type { ThemeDefinition } from './types';

export const academic: ThemeDefinition = {
  variables: {
    '--report-font-display': 'Georgia, serif',
    '--report-font-body': 'Georgia, serif',
    '--report-font-mono': "'Courier New', Courier, monospace",
    '--report-bg': '#ffffff',
    '--report-bg-surface': '#f8f8f8',
    '--report-text': '#000000',
    '--report-text-secondary': '#333333',
    '--report-text-muted': '#666666',
    '--report-accent': '#000000',
    '--report-accent-dim': 'rgba(0, 0, 0, 0.05)',
    '--report-border': '#cccccc',
    '--report-border-strong': '#000000',
    '--report-stat-color': '#000000',
    '--report-stat-positive': '#16a34a',
    '--report-stat-negative': '#dc2626',
    '--report-callout-bg': '#f8f8f8',
    '--report-callout-border': '#000000',
    '--report-surface-hover': '#efefef',
    '--report-code-bg': '#f5f5f5',
    '--report-code-text': '#333333',
    '--report-measure': '720px',
  },
};
